import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('token');

    let headers = request.headers;

    if (token && !headers.has('Authorization')) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    if (!headers.has('Content-Type') && !(request.body instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json');
    }

    // Attach persistent device identifier from localStorage (no logout needed)
    let deviceId = '';
    try {
      deviceId = localStorage.getItem('wp_device_id') || '';
      if (!deviceId) {
        deviceId = (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : 'dev_' + Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
        localStorage.setItem('wp_device_id', deviceId);
      }
    } catch (e) {
      deviceId = 'dev_unknown';
    }

    if (deviceId && !headers.has('X-Device-Id')) {
      headers = headers.set('X-Device-Id', deviceId);
    }

    const authReq = request.clone({ headers });
    return next.handle(authReq);
  }
}
